import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'entityShortName'
})
export class EntityShortNamePipe implements PipeTransform {

  transform(name: string, args?: any): string {
    const lastIndex = name.lastIndexOf('/');
    const result = name.slice(lastIndex + 1);
    return result;
  }

}
